import {Component, OnInit, Inject} from '@angular/core';
import {Router, ActivatedRoute} from "@angular/router";
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";
import {TableService} from "../../shared/services/table/table.service";
import {Table} from "../../shared/model/table";
import {ionicConfig} from "../../../environments/ionic2.config";
import {DOCUMENT} from "@angular/platform-browser";
import {Restaurant} from "../../shared/model/restaurant";

@Component({
  selector: 'print-qrcodes',
  templateUrl: './print-qrcodes.component.html',
  styleUrls: ['./print-qrcodes.component.css']
})
export class PrintQRCodesComponent implements OnInit {
  private restaurantId: string;
   currentRestaurantName: string;
  private  currentNumberOfTables:number;
   tables:Table[];
  private base:string;
   restaurant: Restaurant;

  constructor(
      private route: ActivatedRoute,
      private router:Router,
      private restaurantservice:RestaurantService,
      private tableservice:TableService,
    @Inject(DOCUMENT) private document



  ) {

    // this.base = ionicConfig.host + ionicConfig.port+ '/'+ ionicConfig.iniURL + '/';
    this.base = ionicConfig.host + ionicConfig.port+ ''+ ionicConfig.iniURL + '?t=';

    route.data
      .subscribe( ( data : {restaurant:Restaurant  }) =>
        {
          this.restaurant = data.restaurant;
        }

      )



  }

  ngOnInit() {


    this.restaurantId = this.restaurant.$key;


    this.currentRestaurantName = this.restaurant.restaurant;


    this.tableservice.getTables(this.restaurantId)
        .subscribe((tables) => {
          this.currentNumberOfTables  = tables.length;
          this.tables = tables;
        });

  }

  allOrNothing(){
    let allCheck = Object.assign(document.getElementsByClassName('all')[0]);
    let isChecked = allCheck.checked;
    let QRChecks = document.getElementsByClassName('printme');


    this.tables.forEach((innerElement,index) => {
      let mySelected =   Object.assign(QRChecks[index]);
      mySelected.checked = isChecked;
    });
  }

  print(){
      let popupWindow = window.open('', '_blank', 'width=1000,height=950,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');

      popupWindow.document.write(
        `
        <html>
          <head>
            <title> RQ Codes </title>
            <style>

              .print-label{
                padding: 10px;
                text-align: center;
                border-style: dashed;
                width: 250px;
                height: 245px;
                margin: 17px;
              }
              .print-page{
                background-color: white;
                height:1500px;
              
              }
              
              .form-buttons{
                /*margin-top: 15px;*/
                margin-bottom: 25px;
                text-align: -webkit-center;
              }
              

            </style>
          </head>
          <body>
              <div class="print-page" id="print-page">
                <table>
              `
      );
      let myI = 0;
      let QRChecks = document.getElementsByClassName('printme');
        this.tables.forEach((innerElement,index) => {
          let tableName = innerElement.tableName;
          let selectedID = "cbox_" + index;
          let mySelected =   Object.assign(QRChecks[index]);

          if ( myI % 3 == 0){
            popupWindow.document.write('<tr>');
          }
          let imageNumber = index;
          let imageID = "img_"+imageNumber;
          let myCode = document.getElementById(imageID);
          // console.log(myCode);
          if (mySelected.checked) {
            popupWindow.document.write(
              `
                    <td >
                    <div class="print-label">
                      <div style="font-size: smaller; margin-top: -5px">
              To call for service
            use your favorite <br>QR CODE SCANNER</div><br>
                      <label>
                      `
              +
              innerElement.tableName
              +
              `
                      </label>
                      <div class="qr-size-class">
                       ` + myCode.innerHTML + `
                       </div>
                    </div>
                    </td>
                    `
            );
            if (myI % 3 == 2) {
              popupWindow.document.write('</tr>');
            }
            myI++;
          }
        });
    popupWindow.document.write(

          `
                </table>
              </div>
          </body>
        </html>
        
        `);

      popupWindow.document.close(); // necessary for IE >= 10
      popupWindow.focus(); // necessary for IE >= 10*/

      popupWindow.print();
      popupWindow.close();
  }


  cancel(){

    this.router.navigate(['/restaurants/'+this.restaurantId])
  }
}



// WEBPACK FOOTER //
// ./src/app/table/print-qrcodes/print-qrcodes.component.ts